import type {Store} from "redux"
export {connect} from "react-redux"

/**
 * Singleton instance of the redux store
 * @deprecated This should not be accessed directly
 */
export let store = null as unknown as Readonly<Store>

/**
 * Call in platform specific init code to set up the redux store
 *
 * This is only needed because much code imports the store as a singleton,
 * ideally it should come from context if we ever refactor this for use
 */
export function confgureStore(configuredStore: Store) {
  if (store !== null) {
    console.warn("store already created, this should only have been called once")
  }
  store = configuredStore
}
